var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09436 16.2504H15.8994C17.311 16.2504 18.191 14.7195 17.4852 13.5004L10.5827 1.57453C9.87686 0.355365 8.11686 0.355365 7.41102 1.57453L0.508523 13.5004C-0.197311 14.7195 0.682689 16.2504 2.09436 16.2504ZM8.99686 9.8337C8.49269 9.8337 8.08019 9.4212 8.08019 8.91703V7.0837C8.08019 6.57953 8.49269 6.16703 8.99686 6.16703C9.50102 6.16703 9.91352 6.57953 9.91352 7.0837V8.91703C9.91352 9.4212 9.50102 9.8337 8.99686 9.8337ZM9.91352 13.5004H8.08019V11.667H9.91352V13.5004Z",
    fill: "#CC454D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorWarning);
export default __webpack_public_path__ + "static/media/ErrorWarning.0622314805a252e539610fb231602eaf.svg";
export { ForwardRef as ReactComponent };